import React, { lazy, Suspense } from 'react';

const CustomerPhone = lazy(() => {
  switch (process.env.REACT_APP_CUSTOMER) {
    case 'frs':
      return import('owl/customers/frs/Phone');
    case 'trindco':
      return import('owl/customers/trindco/Phone');
    case 'tcf':
      return import('owl/customers/tcf/Phone');
    case 'simple':
      return import('owl/customers/simple/Phone');
    case 'dev':
      return import('owl/customers/dev/Phone');
    default:
      console.log('REACT_APP_CUSTOMER', process.env.REACT_APP_CUSTOMER);
      throw new Error('REACT_APP_CUSTOMER not set');
  }
});

export const Phone = () => {
  return (
    <>
      <Suspense>
        <CustomerPhone />
      </Suspense>
    </>
  );
};

export default Phone;
